module.exports = __webpack_public_path__ + "img/t4-i14.b2c9ca98.jpg";